export default __webpack_public_path__ + "b192024869bd0a0b3b585397f3e3ccbe.otf";